import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Icon from '../icon/Icon';
import { ICONS } from '../icon/Icons';
import { pure } from 'recompose';
import {
  ModalContainer,
  ModalHeader,
  MenuButton,
  ContentContainer,
  TRANSITION_DURATION,
} from './ui/';

const renderCloseButton = (props) => {
  const {
    onClose
  } = props;
  return (
    <MenuButton onClick={onClose}>
      <Icon icon={ICONS.CLOSE} />
    </MenuButton>
  );
}

const Modal = (props) => {
  const { children, isOpen, title } = props;
  return (
    <ReactCSSTransitionGroup
      component="div"
      transitionName="modal"
      transitionAppear={true}
      transitionAppearTimeout={TRANSITION_DURATION}
      transitionEnter={true}
      transitionEnterTimeout={TRANSITION_DURATION}
      transitionLeave={true}
      transitionLeaveTimeout={TRANSITION_DURATION}
    >
      {isOpen &&
        <ModalContainer key="modal" first>
          <ModalHeader>
            <MenuButton />
            <h2>{title}</h2>
            {renderCloseButton(props)}
          </ModalHeader>
          <ContentContainer>
            { children }
          </ContentContainer>
        </ModalContainer>
      }
    </ReactCSSTransitionGroup>
  );
};

export default pure(Modal);


// WEBPACK FOOTER //
// ./src/modules/common/components/modal/Modal.js